var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-kanban-view" },
    [
      _vm.dropdownFields.length === 0
        ? _c(
            "div",
            { staticClass: "kanban-empty-state" },
            [
              _c("a-empty", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "description",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "empty-state-content" },
                            [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(_vm.$t("tables.kanbanNotAvailable"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.$t("tables.needDropdownField"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.switchToTableView },
                                },
                                [_vm._v(_vm._s(_vm.$t("tables.switchToTable")))]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1905689240
                ),
              }),
            ],
            1
          )
        : [
            _c("KanbanToolbar", {
              attrs: {
                fields: _vm.dropdownFields,
                selectedField: _vm.$_.get(_vm.kanbanSettings, "kanbanField"),
                records: _vm.records,
                kanbanField: _vm.getKanbanFieldAsObject(),
                groupValue: _vm.groupValue,
                kanbanSettings: _vm.kanbanSettings,
              },
              on: {
                "change-field": _vm.onChangeField,
                "open-settings": function ($event) {
                  _vm.overlayVisible = true
                },
              },
            }),
            _vm._v(" "),
            _c("KanbanBoard", {
              attrs: {
                records: _vm.records,
                kanbanSettings: _vm.kanbanSettings,
                table: _vm.table,
                selectedRecords: _vm.selectedRecords,
                isSelectionModeActive: _vm.isSelectionModeActive,
                getRecordColor: _vm.getRecordColor,
                groupValue: _vm.groupValue,
              },
              on: {
                "update-record": _vm.updateRecord,
                "toggle-selection": function ($event) {
                  return _vm.$emit("toggle-selection", $event)
                },
              },
            }),
            _vm._v(" "),
            _vm.overlayVisible
              ? _c("KanbanSettingsOverlay", {
                  attrs: {
                    fields: _vm.table.fields,
                    kanbanSettings: _vm.kanbanSettings,
                  },
                  on: {
                    close: function ($event) {
                      _vm.overlayVisible = false
                    },
                    saveSettings: _vm.saveKanbanSettings,
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }